import { TimeSlot } from "@hubcapp/types";
import { format } from "date-fns";
import { lessonPaidStatus } from "@hubcapp/components/Calendar/components/Modals/AddLessonModal/components/BookingConflictTable";
import { makeStyles } from "@material-ui/core";
import React, { ReactElement } from "react";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  listItem: {
    display: "grid",
    gridTemplateColumns: "10fr 7fr 7fr",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    padding: "18px 0",
    alignItems: "center",
  },
  itemDate: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "22px",
    letterSpacing: "0.1px",
    display: "flex",
    gap: "8px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "2px",
    },
  },
  status: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  colored: {
    width: "4px",
    height: "18px",
    "&.prepaid": {
      backgroundColor: "#3DC0DB",
    },
    "&.notpaid": {
      backgroundColor: "#F9812A",
    },
  },
}));

interface Props {
  timeSlot: TimeSlot;
  label: ReactElement;
  status: lessonPaidStatus | null;
}

export const TimeSlotListItem: React.FC<Props> = ({
  timeSlot,
  label,
  status,
}) => {
  const classes = useStyles();
  return (
    <li key={timeSlot.startDateTime} className={classes.listItem}>
      <div className={classes.itemDate}>
        <span>{format(new Date(timeSlot.startDateTime), "dd/MM/yyyy")}</span>
        <span>
          {format(new Date(timeSlot.startDateTime), "HH:mm")}
          &nbsp;-&nbsp;
          {format(new Date(timeSlot.endDateTime), "HH:mm")}
        </span>
      </div>
      <div>{label}</div>
      {status && (
        <div className={classes.status}>
          <div
            className={clsx(classes.colored, {
              prepaid: status === "Pre-paid",
              notpaid: status === "Not-paid",
            })}
          />
          {status}
        </div>
      )}
    </li>
  );
};
